export default __webpack_public_path__ + "static/media/next-day.24fabd72.png";